import { render, staticRenderFns } from "./PlanIndex.vue?vue&type=template&id=4770d748&scoped=true"
import script from "./PlanIndex.vue?vue&type=script&lang=js"
export * from "./PlanIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770d748",
  null
  
)

export default component.exports